import { CatalogService } from './CatalogService';

export class PriceTypeService extends CatalogService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
}
// import {AppEntities, AppServices} from "../../config/entities";

// export class PriceTypeService {
//     async GetAll(searchText: string | undefined) {
//         console.log("GetAll");
//         let url = AppEntities.PriceType.apiUrl;
//         if (searchText) {
//             url += "?searchText=" + searchText;
//         }

//         const response = await AppServices.Axios.get(url);
//         return response.data;
//     }

//     async GetAllCustomers(searchText: string | undefined) {
//         console.log("GetAll");
//         let url = AppEntities.PriceType.apiUrl + "/customers";
//         if (searchText) {
//             url += "?searchText=" + searchText;
//         }

//         const response = await AppServices.Axios.get(url);
//         return response.data;
//     }

//     async GetAllPriceTypes (searchText: string | undefined) {
//         console.log("GetAll");
//         let url = AppEntities.PriceType.apiUrl + "/PriceType";
//         if (searchText) {
//             url += "?searchText=" + searchText;
//         }

//         const response = await AppServices.Axios.get(url);
//         return response.data;
//     }    

//     async Get(id: string) {
//         console.log("Get", id);
//         const response = await AppServices.Axios.get(AppEntities.PriceType.apiUrl + "/" + id);
//         return response.data;
//     }

//     async Delete(selectedItemId: string | null) {
//         if (selectedItemId) {
//             console.log("Delete", selectedItemId);
//             const response = await AppServices.Axios.delete(AppEntities.PriceType.apiUrl + "/" + selectedItemId);
//             console.log("Delete response", response);
//         }
//     }

//     async Update(model: any) {
//         console.log("Update", model);
//         const response = await AppServices.Axios.put(AppEntities.PriceType.apiUrl, model);
//         console.log("Update response", response);
//     }

//     async Create(model: any) {
//         console.log("Create", model);
//         const response = await AppServices.Axios.post(AppEntities.PriceType.apiUrl, model);
//         console.log("Create response", response);
//     }
// }